interface BackButtonProps {
  label: string;
  onClick: () => void;
}

export function BackButton({ label, onClick }: BackButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="text-primary-600 hover:text-primary-700 mb-4 self-start"
    >
      ← {label}
    </button>
  );
}
